import React, {useState} from 'react';
import styles from './styles';
import {Icons, Button} from '@xpertdox_js/xdcomponents';
import {colors} from '@xpertdox_js/xdstyle';
import { UserContext } from '../../Context/UserContext'
import { InstanceContext } from '../../InstanceContext'
import { trackActivity } from '../../utils/activityTracker'

const EditQuestion = props => {

	const {newQuestion, addQuestion, type} = props;
	const [selectInput, setSelectInput] = useState(() => '')
	const [tempEligibility, setTempEligibility] = useState(null)
  const [warnOptions, setWarnOptions] = useState(false)
  const { user } = React.useContext(UserContext)
  const { contextInstance } = React.useContext(InstanceContext)

  const handleActivityLogUpdate = (_id) => {
    trackActivity({
      body: {
        _id,
        instance: contextInstance || user.instance,
        user: user.id
      }
    })
  }

	const setQuestionType = (e, type) => {
		newQuestion.set({
			...newQuestion.value,
			type
    })
    handleActivityLogUpdate(`EditQuestion.setQuestionType.(${type})`)
	}

	const handleInputChange = (event) => setSelectInput(event.target.value)

	const handleAddOption = (event) => {
	  console.log(selectInput, event, "INPUT")
		if(!selectInput) return;
		let options = newQuestion.value.options ? newQuestion.value.options : [];
		if(event.key) {
			switch (event.key) {
				case 'Enter':
				case 'Tab':
				newQuestion.set({
					...newQuestion.value,
					options: [...options, {label: selectInput, value: selectInput, optionType: type === 'surveyQuestions' ? null : tempEligibility }]
				});
				event.preventDefault();
				setSelectInput('')
			}
		} else {
			if(!tempEligibility && props.type !== 'surveyQuestions') {
				setWarnOptions('Select Eligibility')
			} else {
				newQuestion.set({
					...newQuestion.value,
					options: [...options, {label: selectInput, value: selectInput, optionType: type === 'surveyQuestions' ? null : tempEligibility }]
				});
        event.preventDefault();
				setSelectInput('')
			}
    }
    handleActivityLogUpdate(`EditQuestion.handleAddOption`)
	}

	const inputChange = e => {
		newQuestion.set({
			...newQuestion.value,
			label: e.target.value
		})
	}

	const removeOption = (e,index) => {
		let newOptionsSet = [...newQuestion.value.options];
		newOptionsSet.splice(index, 1);
		newQuestion.set({
			...newQuestion.value,
			options: newOptionsSet
    })
    handleActivityLogUpdate(`EditQuestion.removeOption`)
	}

	const selectEligibility = (e, type) => setTempEligibility(type)

	const renderInputRadio = (type, i) => <span key={i} onClick={e => selectEligibility(e, type)} style={
			{display: 'flex', fontSize: 14, marginRight: 5, marginTop: 5}}
		>
		<Icons icon={tempEligibility === type ? 'check' : 'circleOutline'} style={{
			height: 15,
			width: 15,
			color: type === 'out' ? colors.error : colors.success,
			fill: type === 'out' ? colors.error : colors.success,
			marginRight: 3
		}}/>
		{type === 'out' ? 'Ineligible' : 'Eligible'}
	</span>

	const showSaveButton = type === 'surveyQuestions'
		? newQuestion.value.label !== ''
		: newQuestion.value.label !== '' && (newQuestion.value.options && newQuestion.value.options.length !== 0);

	return <div style={styles.questionEdit.container}>

		<label style={styles.questionEdit.label}>
			<span style={{ fontWeight: 600}}>Question</span>
			<input style={{...styles.textInput, marginTop: 5}} value={newQuestion.value.label} onChange={inputChange}/>
		</label>

		<div style={styles.questionEdit.options}>
			<p style={{fontWeight: 600, margin: '0px 0px 8px 0px'}}>Dropdown Answers</p>

			<div style={styles.questionEdit.addOptionContainer}>
				<input
					style={{
						...styles.textInput,
						marginBottom: 5,
						minWidth: 200,
					}}
					value={selectInput.label ? selectInput.label : selectInput}
					placeholder="Add answer..."
					onChange={handleInputChange}
					onKeyDown={handleAddOption}
				/>
				<Button
					onClick={handleAddOption}
					styles={{
						...styles.button.container,
						marginTop: '-6px',
						width: 80,
						marginLeft: 5,
						height: 30
					}}
					hoverStyles={styles.button.buttonHov}
					focusStyles={styles.button.buttonFoc}
					title="Add">
					<span>Add Answer</span>
				</Button>
			</div>
			{
				type !== 'surveyQuestions' &&
				<div style={{bottom: 9, left: 5, display:'flex', flexDirection: 'row', cursor: 'pointer'}}>
					{['in', 'out'].map((type, i) => renderInputRadio(type, i))}
				</div>
			}
			{warnOptions && <span style={{marginTop: 5, marginLeft: 2, color: colors.error, fontWeight: 700, fontSize: 11}}>{warnOptions}</span>}

			<div style={styles.questionEdit.addedOptionsContainer}>
				{newQuestion.value.options && newQuestion.value.options.map((o, index) => {
					return <span key={index} style={{fontSize: 13, marginRight: 8}}>
						{o.label} {o.optionType && <span>{o.optionType === 'out' ? ' (Ineligible) ' : ' (Eligible) '}</span>}
						<span style={{color: colors.xdHighlight,cursor: 'pointer'}}>
							<Icons icon='trash' onClick={e => removeOption(e, index)} style={{height: 16, width: 16, fill: colors.error}} />
						</span>
					</span>
				})}
			</div>
		</div>

		{showSaveButton && <React.Fragment>
			<Button
				onClick={addQuestion}
				styles={{
					...styles.button.container,
					backgroundColor: colors.success,
					marginTop: 15
				}}
				hoverStyles={styles.button.buttonHov}
				focusStyles={styles.button.buttonFoc}
				title="Add Question">
				<span>Add Question</span>
			</Button>
			<p style={{margin: 5, color: colors.error, fontWeight: 700}}>*Don't forget to click the save button above in order to save this question for this trial.</p>
		</React.Fragment>}

	</div>
}

export default EditQuestion;
